
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RadioOption from "@/entities/RadioOption";

  @Component
  export default class RadioButtonGroup extends Vue {
    @Prop({ default: "all", type: String }) value!: string;
    @Prop({ required: true, type: Array }) options!: RadioOption[];
    @Prop({ default: "radioChoice", type: String }) name!: string;
    @Prop({ type: Boolean, default: false }) blue!: boolean;

    handleChange(event: any) {
      this.$emit("input", event.target.value);
    }
  }
